var moduleMap = {
	"./test": () => {
		return __webpack_require__.e(865).then(() => (() => ((__webpack_require__(2865)))));
	},
	"./handlers": () => {
		return Promise.all([__webpack_require__.e(237), __webpack_require__.e(163), __webpack_require__.e(440)]).then(() => (() => ((__webpack_require__(8888)))));
	},
	"./mfeConfig": () => {
		return __webpack_require__.e(411).then(() => (() => ((__webpack_require__(1905)))));
	},
	"./cloudEnv": () => {
		return __webpack_require__.e(411).then(() => (() => ((__webpack_require__(7627)))));
	},
	"./apiRequestsUtils": () => {
		return Promise.all([__webpack_require__.e(893), __webpack_require__.e(417), __webpack_require__.e(95), __webpack_require__.e(180), __webpack_require__.e(582), __webpack_require__.e(411), __webpack_require__.e(714), __webpack_require__.e(556)]).then(() => (() => ((__webpack_require__(714)))));
	},
	"./navigationUtils": () => {
		return __webpack_require__.e(138).then(() => (() => ((__webpack_require__(8138)))));
	},
	"./mountComponent": () => {
		return Promise.all([__webpack_require__.e(893), __webpack_require__.e(417), __webpack_require__.e(532), __webpack_require__.e(156), __webpack_require__.e(29), __webpack_require__.e(4), __webpack_require__.e(572), __webpack_require__.e(95), __webpack_require__.e(180), __webpack_require__.e(582), __webpack_require__.e(411), __webpack_require__.e(714), __webpack_require__.e(497), __webpack_require__.e(424), __webpack_require__.e(643), __webpack_require__.e(539), __webpack_require__.e(263), __webpack_require__.e(395)]).then(() => (() => ((__webpack_require__(5395)))));
	},
	"./utils": () => {
		return Promise.all([__webpack_require__.e(893), __webpack_require__.e(95), __webpack_require__.e(582)]).then(() => (() => ((__webpack_require__(582)))));
	},
	"./constants": () => {
		return __webpack_require__.e(154).then(() => (() => ((__webpack_require__(1154)))));
	},
	"./queryUtils": () => {
		return Promise.all([__webpack_require__.e(417), __webpack_require__.e(934)]).then(() => (() => ((__webpack_require__(7934)))));
	},
	"./storeUtils": () => {
		return Promise.all([__webpack_require__.e(95), __webpack_require__.e(265)]).then(() => (() => ((__webpack_require__(7265)))));
	},
	"./docUtils": () => {
		return Promise.all([__webpack_require__.e(893), __webpack_require__.e(417), __webpack_require__.e(95), __webpack_require__.e(180), __webpack_require__.e(582), __webpack_require__.e(411), __webpack_require__.e(714), __webpack_require__.e(497), __webpack_require__.e(834)]).then(() => (() => ((__webpack_require__(9878)))));
	},
	"./datetimeUtils": () => {
		return Promise.all([__webpack_require__.e(180), __webpack_require__.e(465)]).then(() => (() => ((__webpack_require__(4465)))));
	},
	"./notificationUtils": () => {
		return Promise.all([__webpack_require__.e(95), __webpack_require__.e(416)]).then(() => (() => ((__webpack_require__(8035)))));
	},
	"./helperUtils": () => {
		return __webpack_require__.e(180).then(() => (() => ((__webpack_require__(3180)))));
	},
	"./RetentionForm": () => {
		return Promise.all([__webpack_require__.e(893), __webpack_require__.e(417), __webpack_require__.e(532), __webpack_require__.e(156), __webpack_require__.e(4), __webpack_require__.e(95), __webpack_require__.e(180), __webpack_require__.e(582), __webpack_require__.e(411), __webpack_require__.e(714), __webpack_require__.e(497), __webpack_require__.e(424), __webpack_require__.e(643), __webpack_require__.e(263), __webpack_require__.e(192)]).then(() => (() => ((__webpack_require__(6263)))));
	},
	"./ltrUtils": () => {
		return Promise.all([__webpack_require__.e(424), __webpack_require__.e(47)]).then(() => (() => ((__webpack_require__(8424)))));
	},
	"./listProcessingUtils": () => {
		return Promise.all([__webpack_require__.e(156), __webpack_require__.e(56)]).then(() => (() => ((__webpack_require__(8056)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});